webpackJsonp([114276838955818,60335399758886],{

/***/ 104:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(216);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(104);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(96);
	var isArguments = __webpack_require__(95);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(127);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(94);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(123);
	
	var _HelmetConstants = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(98);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(128);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.trackEvent = trackEvent;
	function isGAEnabled() {
	  return ("production") === 'production' && typeof window.ga === 'function';
	}
	
	function ga() {
	  if (isGAEnabled()) {
	    var _window;
	
	    (_window = window).ga.apply(_window, arguments);
	  }
	}
	
	function trackEvent(eventCategory, eventAction, eventLabel) {
	  ga('send', {
	    hitType: 'event',
	    eventCategory: eventCategory,
	    eventAction: eventAction,
	    eventLabel: eventLabel
	  });
	}
	
	// use this global only when necessary (outside of the bundle, e.g. contact form)
	global.trackEvent = trackEvent;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = CopyRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CopyRight(_ref) {
	  var year = _ref.year,
	      link = _ref.link,
	      name = _ref.name;
	
	  return _react2.default.createElement(
	    "div",
	    { id: "copy-rights", className: "col s12" },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "p",
	        null,
	        "Copyright \xA9 ",
	        year,
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: link },
	          name
	        )
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(122);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _icon = __webpack_require__(454);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var themeLinks = [{ rel: 'icon', href: _icon2.default }, { rel: 'stylesheet', href: '/css/materialize.min.css' }, { rel: 'stylesheet', href: '/css/owl.carousel.min.css' }, { rel: 'stylesheet', href: '/css/animate.css' }, { rel: 'stylesheet', href: '/css/aos.css' }, { rel: 'stylesheet', href: '/css/lity.min.css' }, { rel: 'stylesheet', href: '/css/font-awesome.min.css' }];
	
	var styleLinks = themeLinks.filter(function (link) {
	  return link.rel === 'stylesheet';
	});
	
	// attach load listeners
	styleLinks.forEach(function (link) {
	  link.onload = 'onStyleLoad()';
	});
	
	var numLoaded = 0;
	global.onStyleLoad = function onStyleLoaded() {
	  numLoaded++;
	  if (numLoaded === styleLinks.length) {
	    // hide loader as soon as styles are available
	    document.querySelector('.pre-loader').className += ' fade-out';
	  }
	};
	
	function Head() {
	  return _react2.default.createElement(_reactHelmet2.default, {
	    title: 'Conf One | Your number one application for conference',
	    meta: [{
	      name: 'description',
	      content: 'Your number one application for conference'
	    }, { name: 'keywords', content: 'conference,app,schedule,attendees' }, { name: 'robots', content: 'index, follow' }, { name: 'author', content: 'instea.co' }],
	    link: themeLinks
	  });
	}
	
	exports.default = Head;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ga = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trackMenuClick(item) {
	  return function trackMenuClickHanler() {
	    (0, _ga.trackEvent)('navigation', 'click', item.title);
	    return !!item.href;
	  };
	}
	
	var Nav = function Nav(_ref) {
	  var titleImg = _ref.titleImg,
	      logoImg = _ref.logoImg,
	      items = _ref.items,
	      logoItem = _ref.logoItem;
	  return _react2.default.createElement(
	    'nav',
	    { id: 'main-nav', className: 'nav-down' },
	    _react2.default.createElement('div', { id: 'nav-color', className: 'gradient-color' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'nav-wrapper' },
	      _react2.default.createElement(
	        'a',
	        {
	          className: 'brand-logo design-font waves-effect waves-light no-bg left-align',
	          'data-scroll-nav': logoItem.dataScrollNav,
	          href: logoItem.href || '#'
	        },
	        _react2.default.createElement('img', {
	          className: 'responsive-img logo',
	          src: logoImg || 'http://placehold.it/120x120',
	          alt: ''
	        }),
	        titleImg && _react2.default.createElement('img', { className: 'responsive-img title', src: titleImg, alt: '' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', 'data-activates': 'mobile-demo', className: 'button-collapse' },
	        _react2.default.createElement(
	          'div',
	          { className: 'very_small_hamburger', id: 'hamburger-menu' },
	          _react2.default.createElement(
	            'svg',
	            { viewBox: '0 0 800 600' },
	            _react2.default.createElement('path', {
	              d: 'M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200',
	              className: 'top'
	            }),
	            _react2.default.createElement('path', { d: 'M300,320 L540,320', className: 'middle' }),
	            _react2.default.createElement('path', {
	              d: 'M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190',
	              className: 'bottom',
	              transform: 'translate(480, 320) scale(1, -1) translate(-480, -318) '
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'right hide-on-med-and-down' },
	        items.map(function (item) {
	          return _react2.default.createElement(
	            'li',
	            { key: item.title },
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'waves-effect waves-light' + (item.dataScrollNav === 0 ? ' no-bg' : ''),
	                onClick: trackMenuClick(item),
	                'data-scroll-nav': item.dataScrollNav,
	                href: item.href || '#'
	              },
	              item.title
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'side-nav', id: 'mobile-demo' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'waves-effect waves-light home  no-bg',
	              'data-scroll-nav': '0',
	              href: '#'
	            },
	            _react2.default.createElement('img', {
	              className: 'responsive-img logo',
	              src: logoImg || 'http://placehold.it/120x120',
	              alt: 'Conf-One'
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('img', {
	              className: 'responsive-img title',
	              src: titleImg || 'http://placehold.it/100x17',
	              alt: 'Conf-One'
	            })
	          )
	        ),
	        items.map(function (item) {
	          return _react2.default.createElement(
	            'li',
	            { key: item.title },
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'waves-effect waves-light',
	                'data-scroll-nav': item.dataScrollNav,
	                onClick: trackMenuClick(item),
	                href: item.href || '#'
	              },
	              item.title
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PreLoader = function PreLoader() {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'pre-loader gradient-color',
	      style: {
	        zIndex: 10000,
	        backgroundColor: 'white',
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        width: '100%',
	        height: '100%'
	      }
	    },
	    _react2.default.createElement('div', { className: 'loader' })
	  );
	};
	
	exports.default = PreLoader;
	module.exports = exports['default'];

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	__webpack_require__(310);
	
	__webpack_require__(309);
	
	__webpack_require__(308);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Head = __webpack_require__(204);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _CopyRight = __webpack_require__(203);
	
	var _CopyRight2 = _interopRequireDefault(_CopyRight);
	
	var _Nav = __webpack_require__(205);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _PreLoader = __webpack_require__(207);
	
	var _PreLoader2 = _interopRequireDefault(_PreLoader);
	
	var _logoImg = __webpack_require__(455);
	
	var _logoImg2 = _interopRequireDefault(_logoImg);
	
	var _logoText = __webpack_require__(456);
	
	var _logoText2 = _interopRequireDefault(_logoText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // critical Apperle theme styles
	
	
	var indexNav = [{
	  title: 'Home',
	  dataScrollNav: 0
	}, {
	  title: 'Features',
	  dataScrollNav: 1
	}, {
	  title: 'Screenshots',
	  dataScrollNav: 2
	}, {
	  title: 'Demo',
	  dataScrollNav: 3
	}, {
	  title: 'Pricing',
	  dataScrollNav: 5
	}, {
	  title: 'Contact',
	  dataScrollNav: 8
	}, {
	  title: 'Blog',
	  href: '/blog'
	}];
	
	// TODO: page transitions using router
	var blogNav = [{
	  title: 'Home',
	  href: '/'
	}, {
	  title: 'Blog',
	  href: '/blog'
	}];
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.render = function render() {
	    var children = this.props.children;
	
	    var isIndex = this.isIndexRoute();
	    var nav = isIndex ? indexNav : blogNav;
	    var logoItem = isIndex ? { dataScrollNav: 0 } : { href: '/' };
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Head2.default, null),
	      _react2.default.createElement(_PreLoader2.default, null),
	      _react2.default.createElement(_Nav2.default, {
	        logoImg: _logoImg2.default,
	        titleImg: _logoText2.default,
	        items: nav,
	        logoItem: logoItem
	      }),
	      children(),
	      _react2.default.createElement(_CopyRight2.default, { year: 2018, name: 'Instea s.r.o.', link: 'http://instea.co' })
	    );
	  };
	
	  TemplateWrapper.prototype.isIndexRoute = function isIndexRoute() {
	    var pathname = this.props.location.pathname;
	
	    return pathname === '/' || pathname.startsWith('/index');
	  };
	
	  TemplateWrapper.prototype.componentDidMount = function componentDidMount() {
	    // init external javascript
	    window.initMaterialize();
	    window.initMainScript();
	    window.initAnimated();
	    window.initContactForm();
	  };
	
	  TemplateWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.isIndexRoute()) {
	      window.initMainScript();
	      window.initContactForm();
	      window.initAnimated();
	    }
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-d24cad1550431f9e63d4.js